import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PETravelHistoriesCardActions = {
  initPeTravelHistoriesCard: ({ commit }, index) => {
    commit('setPeTravelHistoriesCardLock', { index, lock: true })
  },
  peTravelHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        travel_histories: {
          party_id: party.id,
          entry_date: section.entry_date,
          entry_date_format: section.entry_date_format,
          entry_date_uncertain: section.entry_date_uncertain,
          immigration_status: section.immigration_status,
          immigration_status_other: section.immigration_status_other,
          entry_place: section.entry_place,
          entry_place_unknown: section.entry_place_unknown,
          reason_entry_unknown: section.reason_entry_unknown,
          entry_state: section.entry_state,
          entry_via: section.entry_via,
          entry_manner: section.entry_manner,
          entry_documents: section.entry_documents,
          entry_manner_notes: section.entry_manner_notes,
          entry_apprehended: section.entry_apprehended,
          entry_apprehended_confirm: section.entry_apprehended_confirm,
          entry_apprehended_notes: section.entry_apprehended_notes,
          departure_date: section.departure_date,
          departure_date_format: section.departure_date_format,
          departure_date_uncertain: section.departure_date_uncertain,
          departure_place: section.departure_place,
          departure_via: section.departure_via,
          departure_apprehended: section.departure_apprehended,
          what_happened_departure: section.what_happened_departure,
          departure_apprehended_notes: section.departure_apprehended_notes,
          travel_duration: section.travel_duration,
          notes: section.notes,
          what_happened_entry: section.what_happened_entry,
        },
      }).
      then(({ data }) => {
        commit('setPeTravelHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeTravelHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'travel_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peTravelHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/travel_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeTravelHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'travel_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peTravelHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        travel_histories: {
          party_id: party.id,
          entry_date: section.entry_date,
          entry_date_format: section.entry_date_format,
          entry_date_uncertain: section.entry_date_uncertain,
          immigration_status: section.immigration_status,
          immigration_status_other: section.immigration_status_other,
          entry_place: section.entry_place,
          entry_place_unknown: section.entry_place_unknown,
          reason_entry_unknown: section.reason_entry_unknown,
          entry_state: section.entry_state,
          entry_via: section.entry_via,
          entry_manner: section.entry_manner,
          entry_documents: section.entry_documents,
          entry_manner_notes: section.entry_manner_notes,
          entry_apprehended: section.entry_apprehended,
          entry_apprehended_confirm: section.entry_apprehended_confirm,
          entry_apprehended_notes: section.entry_apprehended_notes,
          departure_date: section.departure_date,
          departure_date_format: section.departure_date_format,
          departure_date_uncertain: section.departure_date_uncertain,
          departure_place: section.departure_place,
          departure_via: section.departure_via,
          departure_apprehended: section.departure_apprehended,
          what_happened_departure: section.what_happened_departure,
          departure_apprehended_notes: section.departure_apprehended_notes,
          travel_duration: section.travel_duration,
          notes: section.notes,
          what_happened_entry: section.what_happened_entry,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeTravelHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'travel_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peTravelHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          travel_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const travelHistories = data.travel_histories

        commit('setPeTravelHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          travel_histories: travelHistories || [],
        })
      }).
      catch(handleError)
  },
  peTravelHistoriesCardAddSection: ({ commit }) => {
    commit('setPeTravelHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeTravelHistoriesCardSection', {
      id: null,
      entry_date: null,
      entry_date_format: null,
      entry_date_uncertain: null,
      immigration_status: null,
      immigration_status_other: null,
      entry_place: null,
      entry_place_unknown: null,
      reason_entry_unknown: null,
      entry_state: null,
      entry_via: null,
      entry_manner: null,
      entry_documents: null,
      entry_manner_notes: null,
      entry_apprehended: null,
      entry_apprehended_confirm: null,
      entry_apprehended_notes: null,
      departure_date: null,
      departure_date_format: null,
      departure_date_uncertain: null,
      departure_place: null,
      departure_via: null,
      departure_apprehended: null,
      what_happened_departure: null,
      departure_apprehended_notes: null,
      travel_duration: null,
      notes: null,
      what_happened_entry: null,
    })
  },
}

export const PETravelHistoriesCardMutations = {
  setPeTravelHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.TravelHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'TravelHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.TravelHistoriesCard, index, lock)
  },
  addPeTravelHistoriesCardSection: (state, section) => {
    state.partyEdit.party.travel_histories.push(section)
  },
  peTravelHistoriesCardCreateUndo: state => {
    state.partyEdit.party.travel_histories.pop()
    Vue.set(state.partyEdit.partySections.TravelHistoriesCard, 'new', true)
  },
}

export const PETravelHistoriesCardGetters = {
  peTravelHistoriesCardLock: state => index => state.partyEdit.partySections.TravelHistoriesCard[index],
  peTravelHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    travel_histories?.
    find(history => history.id === null),
}
